import { cn } from "@/common/helpers/utils";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { ArrowDownIcon, ArrowUpIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { getVehicleValuationDateDirection } from "./valuation-date";

interface VehicleValuationDateIndicatorProps {
  value?: Date | string | null;
  referenceDate?: Date | string | null;
  className?: string;
  reserveSpace?: boolean;
}

export function VehicleValuationDateIndicator({
  value,
  referenceDate,
  className,
  reserveSpace = false,
}: VehicleValuationDateIndicatorProps) {
  const { t } = useTranslation("fab");
  const direction = getVehicleValuationDateDirection(value, referenceDate);

  if (!direction || direction === "today") {
    return reserveSpace ? <span className={cn("inline-flex h-4 w-4 shrink-0", className)} aria-hidden="true" /> : null;
  }

  const Icon = direction === "past" ? ArrowDownIcon : ArrowUpIcon;
  const label =
    direction === "past" ? t("fab:VehicleValuationTargetDateInPast") : t("fab:VehicleValuationTargetDateInFuture");

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          className={cn("inline-flex h-4 w-4 shrink-0 cursor-help items-center justify-center", className)}
          role="img"
          aria-label={label}
        >
          <Icon
            className={cn(
              "h-3.5 w-3.5",
              direction === "past" ? "text-amber-600 dark:text-amber-400" : "text-sky-600 dark:text-sky-400",
            )}
          />
        </span>
      </TooltipTrigger>
      <TooltipContent>
        <p>{label}</p>
      </TooltipContent>
    </Tooltip>
  );
}
